const _import_ = file => () => import('../pages/' + file + '.vue')
import { mapGetters } from 'vuex'

export default [
 {
    path: '/',
    name: '服务管理',
    id: 'created',
    iconCls: 'el-icon-s-promotion',//图标样式class
    component: _import_('Main/index'),
    redirect: '/serviceAdmin',
    meta: {
       // 限制必须登录才能浏览
       requireAuth: true,
    },
    children: [
        { path: '/serviceAdmin', hidden:true, component: _import_('Main/module/serviceAdmin'), iconCls: 'el-icon-date', name: '服务管理'},
        { path: '/insertForm', component: _import_('Main/module/insertForm'), iconCls: 'el-icon-edit-outline', name: '创建工单'},
        { path: '/workOrderWait', component: _import_('Main/module/workOrderWait'), iconCls: 'el-icon-edit', name: '待分配工单'},
        // { path: '/workOrderUnComplete', component: _import_('Main/module/workOrderUnComplete'), iconCls:'el-icon-refresh', name: '办理中工单'},
        // { path: '/workOrderFinished', component: _import_('Main/module/workOrderFinished'), iconCls:'el-icon-success', name: '已办结工单'},

        { path: '/ZZselectWaitReceive', component: _import_('Main/module/ZZselectWaitReceive'), iconCls: 'el-icon-s-order', name: '站长待领单'},
        { path: '/ZZselectSendReceive', component: _import_('Main/module/ZZselectSendReceive'), iconCls: 'el-icon-s-opportunity', name: '站长待派单'},
        { path: '/WXselectWaitReceive', component: _import_('Main/module/WXselectWaitReceive'), iconCls: 'el-icon-coordinate', name: '维修待领单'},
        { path: '/WXselectFinishReceive', component: _import_('Main/module/WXselectFinishReceive'), iconCls: 'el-icon-sunny', name: '维修待完成'},
        { path: '/KFselectWaitReceive', component: _import_('Main/module/KFselectWaitReceive'), iconCls: 'el-icon-ice-cream-round', name: '客服待评价'},
        { path: '/KFselectFinishReceive', component: _import_('Main/module/KFselectFinishReceive'), iconCls: 'el-icon-trophy', name: '客服已评价'},

        { path: '/newsAdmin', component: _import_('news/module/newsAdminItem'), hidden:true, iconCls:'el-icon-success', name: '资讯管理'},
        { path: '/newsClient', component: _import_('news/module/newsClient'), hidden:true, iconCls:'el-icon-success', name: '客户端新闻'},
        { path: '/jgAdmin', component: _import_('Main/module/jgAdmin'), hidden:true, iconCls:'el-icon-success', name: '机构管理'},
        { path: '/blockBook', component: _import_('Main/module/blockBook'), hidden:true, iconCls:'el-icon-success', name: '数据看板'},
        { path: '/updateApp', component: _import_('Main/module/updateApp'), hidden:true, iconCls:'el-icon-success', name: 'APP更新'},
        { path: '/hotLine', component: _import_('Main/module/hotLine'), hidden:true, iconCls:'el-icon-success', name: '热线'},
        { path: '/payForm', component: _import_('Main/module/payForm'), hidden:true, iconCls:'el-icon-tickets', name: '报表统计'},
    ]
  },
  {
    path: '/',
    name: '员工管理',
    hidden:true,
    leaf: true,//只有一个节点
    component: _import_('Main/index'),
    redirect: '/ygAdmin',
    iconCls: 'el-icon-message',//图标样式class
    meta: {
       // 限制必须登录才能浏览
       requireAuth: true,
    },
    children: [
      { path: '/ygAdmin', component: _import_('Main/module/ygAdmin'), iconCls: 'el-icon-date', name: '员工管理'},
      { path: '/deptAdmin', component: _import_('Main/module/deptAdmin'), iconCls: 'el-icon-date', name: '部门管理'},
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/Main.js